<div class="wrapper">
  <div class="cc visa">
    <div class="container">
      <div class="type mb-17">{{ bankCardData?.cardClass }}</div>
      <div>
        <img
          class="image mb-17"
          src="assets/images/bank-cards/bank_logo.svg"
          alt="leonus logo"
        />
      </div>
    </div>
    <div fxLayoutAlign="space-between center">
      <div class="chips"></div>
      <div class="paywave"></div>
    </div>
    <div class="holder">
      <span class="number">{{ bankCardData?.maskCardNumber | lowercase }}</span>
      <div fxLayoutAlign="space-between center" class="footer">
        <span class="name">{{ bankCardData?.embossName2 }}</span>
      </div>
    </div>
  </div>
</div>
